
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobb",
      function () {
        return require("private-next-pages/jobb.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobb"])
      });
    }
  